// kanbanWorkflowStore — COMPAT SHIM.
//
// The workflow decision logic now lives in a single source of truth,
// kanbanTransitionPolicy.js (which also enforces role permission and the
// subtask-closure guard). This file is kept ONLY so existing importers
// (KanbanBoard, KanbanCardPlugins, KanbanListRow) don't break while they migrate
// to the policy module. Prefer importing from './kanbanTransitionPolicy' directly.
//
// Mapping:
//   setWorkflowTypes(types)            -> setPolicyContext({ taskTypes: types })
//     (legacy callers passed only the types; roles/allTasks default to empty, so
//      the permission gate tolerates the missing contract and the subtask guard
//      finds no children — i.e. behaviour identical to the old reachable-only store)
//   getTransitionTargets(typeId, st)   -> getAllowedTargets({ data: { type, state } })
//   getStateLabel(typeId, stateId)     -> getStateLabel (re-exported as-is)

import {
  setPolicyContext,
  getAllowedTargets,
  getStateLabel as _getStateLabel,
} from './kanbanTransitionPolicy';

/** @deprecated Use setPolicyContext({ taskTypes, userRoles, allTasks }). */
export function setWorkflowTypes(types) {
  setPolicyContext({ taskTypes: types });
}

/**
 * @deprecated Use getAllowedTargets(task).
 * @param {string|number} typeId  the task's field_task_type term id
 * @param {string} currentState   the task's current workflow state id
 * @param {string|number} [taskId]  the task node id — REQUIRED for the
 *   subtask-closure guard to find the row's open children; without it the guard
 *   is silently inert (the list would offer a move the server then refuses 422).
 * @returns {{to: string, label: string}[]} reachable target states
 */
export function getTransitionTargets(typeId, currentState, taskId) {
  return getAllowedTargets({ data: { id: taskId, type: typeId, state: currentState } });
}

/**
 * @param {string|number} typeId  the task's field_task_type term id
 * @param {string} stateId        the task's current workflow state id
 * @returns {string} the state label, or '' if unknown
 */
export function getStateLabel(typeId, stateId) {
  return _getStateLabel(typeId, stateId);
}
